import { RootState } from 'redux/reducers/rootReducer';

const isWorkerModalOpenSelector = (state: RootState) =>
  state.worker.isWorkerModalOpen;

const workerCreatedAtSelector = (state: RootState) =>
  state.worker.workerCreatedAt;

const workerDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.worker.workerDetailsUpdatedAtByAdmin;

export {
  isWorkerModalOpenSelector,
  workerCreatedAtSelector,
  workerDetailsUpdatedAtByAdminSelector,
};
